import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { parseEntities } from 'parse-entities';

import { TitleLink } from 'common/components';
import { IBasicParagraph } from 'common/interfaces/landing.interface';

import { LinkArrow } from 'components/LinkArrow/LinkArrow';

import './TitleCopyRows.scss';

interface ItemType extends IBasicParagraph {
  paragraphClass?: string;
}

interface Props {
  items?: ItemType[];
  titleNumber?: string;
  containerClass?: string;
  titleClass?: string;
  paragraphClass?: string;
  titleLink?: boolean;
  parseHTML?: boolean;
}

export const TitleCopyRows: React.FC<Props> = ({
  items,
  titleNumber,
  containerClass = '',
  titleClass = '',
  paragraphClass = '',
  titleLink = false,
  parseHTML = false,
}) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {items &&
      items.map(({ field_title, field_description, field_link }) => (
        <div key={field_title} className={`title-copy-rows ${containerClass}`}>
          {field_link ? (
            <TitleLink title={field_title} link={field_link} titleClass={titleClass} />
          ) : (
            <h2 className={`title ${titleClass}`}>
              {titleNumber && <span className="title-number">{titleNumber} </span>}
              {field_title ? parseEntities(field_title) : field_title}{' '}
            </h2>
          )}
          {field_description &&
            (parseHTML ? (
              <div className={`paragraph ${paragraphClass}`}>{ReactHtmlParser(field_description.value)}</div>
            ) : (
              <p className={`paragraph ${paragraphClass}`}>{parseEntities(field_description.value)}</p>
            ))}
          {field_link && (titleLink ? null : <LinkArrow link={field_link} />)}
        </div>
      ))}
  </>
);
